import { render, staticRenderFns } from "./personalHeadSeal.vue?vue&type=template&id=9afbc376&scoped=true"
import script from "./personalHeadSeal.vue?vue&type=script&lang=js"
export * from "./personalHeadSeal.vue?vue&type=script&lang=js"
import style0 from "./personalHeadSeal.vue?vue&type=style&index=0&id=9afbc376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afbc376",
  null
  
)

export default component.exports